import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * SecretsCard extension — registers as an entity-card that attaches to the
 * catalog overview tab (`entity-content:catalog/overview`).
 *
 * The card is loaded lazily; it renders only when the entity has the
 * `devhub.agm/secrets-paths` annotation (the component itself does the check
 * and returns null otherwise, so no extra filter expression is needed).
 */
const secretsEntityCard = EntityCardBlueprint.make({
  name: 'secrets',
  params: {
    loader: async () => {
      const { SecretsCard } = await import('../../components/SecretsCard');
      return <SecretsCard />;
    },
  },
});

export const secretsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [secretsEntityCard],
});
